/**
 * 将数字转换成大写字母
 * @param {*} num 
 */
function numberToLetter(num) {
    return String.fromCharCode(num + 64);
}


export default numberToLetter